import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractChartOfAccountsValidationResult from "./AbstractChartOfAccountsValidationResult.js";

/**
 * Error raised when there is an overlap between two intervals.
 *
 * @param {string} spec.interval - string representation of the interval
 * @param {string} spec.account - account number that is colliding with the interval
 */
export default class OverlappingIntervalsWithAccountsValidationResult extends AbstractChartOfAccountsValidationResult {
	constructor({ interval, account }) {
		super(...arguments);

		this._interval = interval;
		this._account = account;
	}

	getInterval() {
		return this._interval;
	}

	getAccount() {
		return this._account;
	}

	getMessage() {
		return _(
			'Account "{account}" is defined twice: both as a standalone account and part of "{interval}"',
			{
				account: this._account,
				interval: this._interval,
			},
		);
	}

	static getType() {
		return "OverlappingIntervalsWithAccountsValidationResult";
	}
}
